import { useSelector } from "react-redux";
import { ReduxStore } from "$redux/reducers";

export const useLiteralSelectors = () => {
    const literals = useSelector<ReduxStore, {[key: string]: string}>((store) => store.literal.literals)
    const language = useSelector<ReduxStore, string>((store) => store.literal.language)

    return { literals, language };
};
